import React, { Component } from "react";
import "./NewsList.css";

export default class NewsList extends Component {
	constructor(props) {
		super(props);

		this.state = {
			data: props.data
		};
		//console.log("NewsList state ->", this.state.data);
	}

	render() {
		return (
			<div className="NewsList">
				<div className="row middle-scrollPoint">
					{this.state.data.map(function(object, i) {
						return (
							<div className="list-block" key={i}>
								<div className="title">{object.header}</div>
								{object.news_list.map(function(news, index) {
									index++;
									var var1 = news.category;
									var var2 = news.title;
									var var3 = news.description;
									var var4 = news.color;

									if (index !== 0 && index % 3 === 0) {
										return (
											<div key={index} className="small--inline--3">
												<div className="wrapped-item col-xs-12 col-sm-4 col-md-4 col-lg-4">
													<div
														style={{ cursor: "pointer" }}
														className="middle-postblock"
														onClick={() =>
															(window.location.href = `/${news.url}`)
														}
													>
														<div className="NewsList-middle-thumbnailholder">
															<img src={news.image} alt="" />
															<div className="middlepost-thumbnail" />
															<div
																className="load-element"
																style={{ backgroundColor: var4 }}
															/>
														</div>
														<p
															className="middlepost-titldesc"
															dangerouslySetInnerHTML={{
																__html: var1.toUpperCase()
															}}
														/>
														<p
															className="middlepost-titleitem"
															dangerouslySetInnerHTML={{ __html: var2 }}
														/>
														<p
															className="middlepost-description"
															dangerouslySetInnerHTML={{ __html: var3 }}
														/>
														<div className="middle-addelem">
															<a href={"/" + news.url} className="more_button">
																{" "}
															</a>
														</div>
													</div>
												</div>
												<div className="clearfix" />
											</div>
										);
									}
									return (
										<div
											className="wrapped-item col-xs-12 col-sm-4 col-md-4 col-lg-4"
											key={index}
										>
											<div
												className="middle-postblock"
												style={{cursor:'pointer'}}
												onClick={() => (window.location.href = `/${news.url}`)}
											>
												<div className="NewsList-middle-thumbnailholder">
													<img src={news.image} alt="" />
													<div className="middlepost-thumbnail" />
													<div
														className="load-element"
														style={{ backgroundColor: var4 }}
													/>
												</div>
												<p
													className="middlepost-titldesc"
													dangerouslySetInnerHTML={{
														__html: var1.toUpperCase()
													}}
												/>
												<p
													className="middlepost-titleitem"
													dangerouslySetInnerHTML={{ __html: var2 }}
												/>
												<p
													className="middlepost-description"
													dangerouslySetInnerHTML={{ __html: var3 }}
												/>
												<div className="middle-addelem">
													<a href={"/" + news.url} className="more_button">
														{" "}
													</a>
												</div>
											</div>
										</div>
									);
								})}
							</div>
						);
					})}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Components/Elements/NewsList/NewsList.js